// @flow

import type {Container} from 'reactive-di'

import {createElement} from 'react'
import ReactDOM from 'react-dom'

export default function createReactBrowserRenderer<Component: Function>(
    node: Element
): (
    widget: Component,
    attrs: {[id: string]: mixed}
) => void {
    return function render(
        widget: Component,
        attrs: {[id: string]: mixed}
    ): void {
        ReactDOM.render(createElement(widget, attrs), node)
    }
}
